// Colors to move to the theme

export const border_grey = '#dedede';
